@if (isMultiLocation && accountGroupInfo?.napData) {
  <div class="location-cell">
    <div class="title">{{ accountGroupInfo.napData.companyName }}</div>
    <div class="subtitle">{{ accountGroupInfo.napData.address }}</div>
  </div>
} @else {
  <glxy-blank-value></glxy-blank-value>
}
